var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({staticClass:"close iconfont icon-close",class:_vm.pointClass,attrs:{"href":"javascript:;"},on:{"click":_vm.handleClick}},'a',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }